export default __webpack_public_path__ + "static/media/referralsIcon.4fa3efcb.svg";